import mitt from "mitt";

type Events = {
  "set-toolbar-content": any; // Or better: VNode | Component | JSX.Element
};

const emitter = mitt();

export default emitter;